<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div v-if="isRegisterJwt" class="min-h-re2">
      <form @submit="registerUserJWt">
        <div class="vx-card__title mb-4">
          <h4 class="mb-4">Crear una cuenta</h4>
          <p><b>¡Obtén 5 firmas gratis!</b> Rellena los siguientes datos para crear una cuenta.</p>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              v-validate="'required|alpha_spaces|min:3'"
              data-vv-as="nombres"
              data-vv-validate-on="blur"
              label-placeholder="Nombre(s)"
              name="name"
              autocomplete="off"
              placeholder="Nombre(s)"
              v-model="name"
              class="w-full" />
            <span class="text-danger">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              v-validate="'required|alpha_spaces|min:3'"
              data-vv-as="apellidos"
              data-vv-validate-on="blur"
              label-placeholder="Apellidos"
              name="last_name"
              autocomplete="off"
              placeholder="Apellidos"
              v-model="last_name"
              class="w-full" />
            <span class="text-danger">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <vs-input
          v-validate="'required|email'"
          data-vv-validate-on="blur"
          name="email"
          type="email"
          label-placeholder="Correo"
          placeholder="Correo"
          autocomplete="off"
          v-model="email"
          class="w-full mt-6" />
        <span class="text-danger">{{ errors.first('email') }}</span>

<!--        <vs-input
          data-vv-validate-on="blur"
          name="coupon"
          type="text"
          label-placeholder="Ingresa un cupón (opcional)"
          placeholder="Ingresa un cupón (opcional)"
          autocomplete="off"
          v-model="coupon"
          class="w-full mt-6"
        />
        <span class="text-danger">{{ errors.first('coupon') }}</span>-->

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              ref="password"
              :type="type"
              data-vv-validate-on="blur"
              v-validate="'required|min:6|max:16'"
              data-vv-as="contraseña"
              name="password"
              label-placeholder="Password"
              placeholder="Contraseña"
              autocomplete="off"
              v-model="password"
              class="w-full mt-6" />
            <div class="form-control-position field-icon">
              <a @click="showPassword">
                <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
              </a>
            </div>
            <span class="text-danger">{{ errors.first('password') }}</span>
          </div>


          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              :type="type"
              v-validate="'required|min:6|max:16|confirmed:password'"
              data-vv-validate-on="blur"
              data-vv-as="confirmación de contraseña"
              name="confirm_password"
              autocomplete="off"
              label-placeholder="Confirm Password"
              placeholder="Repetir contraseña"
              v-model="password_confirmation"
              class="w-full mt-6" />
            <div class="form-control-position field-icon">
              <a @click="showPassword">
                <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
              </a>
            </div>
            <span class="text-danger">{{ errors.first('confirm_password') }}</span>
          </div>

        </div>

        <div>
          <input
            type="checkbox"
            v-model="isTermsConditionAccepted"
            name="terms"
            v-validate="'required'"
            data-vv-as="términos y condiciones"
            class="d-none">
          <vs-checkbox
            v-model="isTermsConditionAccepted"
            class="mt-6 d-inline-b"
            name="terms"
          ></vs-checkbox>
          <span class="terms">Acepto los <a target="_blank" href="https://verificamex.com/terminos-y-condiciones">Términos y Condiciones</a> del servicio.</span>
          <br><span class="text-danger">{{ errors.first('terms') }}</span>
        </div>
          <div>
            <input
              type="checkbox"
              v-model="isPrivacyNoticeAccepted"
              name="privacy"
              v-validate="'required'"
              data-vv-as="aviso de privacidad"
              class="d-none">
            <vs-checkbox
              v-model="isPrivacyNoticeAccepted"
              class="mt-2 d-inline-b"
              name="privacy"
            ></vs-checkbox>
            <span class="terms">Acepto el <a target="_blank" href="https://verificamex.com/aviso-de-privacidad">Aviso de Privacidad Integral</a> del servicio.</span>
            <br><span class="text-danger">{{ errors.first('privacy') }}</span>
          </div>
        <input type="submit" style="position: absolute; left: -9999px"/>
        <vs-button type="border" to="/login" class="mt-6" >Iniciar sesión</vs-button>
        <vs-button ref="loadableButton" id="button-with-loading" class="mt-6 vs-con-loading__container float-right" :disabled="isSubmitted" @click="registerUserJWt" type="relief" vslor="primary">Registrar</vs-button>
      </form>

    </div>

    <div v-if="isSuccess" class="min-h-re2">
      <div class="vx-card__title mb-4 pt-33p">
        <div class="center-y">
          <h2 class="mb-4">¡Gracias por registrarte!</h2>
          <h4 class="font-w-400 mt-5">Hemos enviado un correo electrónico a <span class="font-w-600 text-primary">{{ email }}</span> para verificar tu identidad. </h4>
          <h4 class="font-w-400 mt-5">En caso de que no lo hayas recibido ve a tu carpeta de Spam o vuelva a enviar otro correo con el siguiente botón.</h4>
          <vs-button ref="loadableButton" id="button-loading-resend" class="mt-6 vs-con-loading__container" :disabled="isSubmittedResendEmail" @click="resend_email" type="relief" vslor="primary">Reenviar correo</vs-button>
<!--          <vs-button @click="resend_email" class=" mt-6">Reenviar correo</vs-button>-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data () {
    return {
      tabIndex: 1,
      icon: 'EyeIcon',
      type: 'password',
      name: '',
      last_name: '',
      email: '',
      password: '',
      coupon: '',
      password_confirmation: '',
      isTermsConditionAccepted: false,
      isPrivacyNoticeAccepted: false,
      isSubmitted: false,
      isSubmittedResendEmail: false,
      utmSource: "",
      utmMedium: "",
      utmCampaign: "",
      gclid: "",
      fbclid: ""
    }
  },
  computed: {
    isRegisterJwt() {
      return this.tabIndex === 1;
    },
    isSuccess() {
      return this.tabIndex === 2;
    }
  },
  methods: {
    resend_email() {
      this.isSubmittedResendEmail = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-loading-resend",
        scale: 0.45
      });
      this.$store.dispatch("account/resend_verification_email", {email: this.email})
      .then(
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        },
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        }
      )
    },
    toggleTab(index) {
      this.tabIndex = index;
    },
    setPhone(email) {
      this.email = email;
    },
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    registerUserJWt (e) {
      if (e) {
        e.preventDefault();
      }
      this.$store.dispatch('alert/clear', {}, { root: true });
      this.isSubmitted = true;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          // Proceed with form submission
          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: "#button-with-loading",
            scale: 0.45
          });
          const user = {
            name: this.name,
            email: this.email,
            last_name: this.last_name,
            password: this.password,
            password_confirmation: this.password_confirmation,
            utm_source: this.utmSource,
            utm_campaign: this.utmCampaign,
            utm_medium: this.utmMedium,
            gclid: this.gclid,
            fbclid: this.fbclid,
            coupon: this.coupon
          }
          this.$store.dispatch('account/register', user)
            .then(() => {
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              this.toggleTab(2);
            })
            .catch(error => {
              console.log('Error al registrar:', error);
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            })
        } else {
          this.$store.dispatch('alert/error', 'Ingrese los datos solicitados', { root: true });
          this.isSubmitted = false;
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.utm_source) {
      this.utmSource = this.$route.query.utm_source
      Cookies.set('utm_source', this.utmSource)
    }
    if (this.$route.query.utm_medium) {
      this.utmMedium = this.$route.query.utm_medium
      Cookies.set('utm_medium', this.utmMedium)
    }
    if (this.$route.query.utm_campaign) {
      this.utmCampaign = this.$route.query.utm_campaign
      Cookies.set('utm_campaign', this.utmCampaign)
    }
    if (this.$route.query.gclid) {
      this.gclid = this.$route.query.gclid
      Cookies.set('gclid', this.gclid)
    }
    if (this.$route.query.fbclid) {
      this.fbclid = this.$route.query.fbclid
      Cookies.set('fbclid', this.fbclid)
    }
  }
}
</script>

<style lang="scss">
.d-inline-b {
  display: inline-block!important;
}
.terms{
  position: relative;
  top: -5px;
}

.is-invalid {
  border-color: red !important;
}
.text-danger {
  color: red;
  font-size: 12px;
}
</style>
